<template>
	<ja-modal ref="modal" :show="show" class="modal-wrapper">
		<content class="session-expire-modal">
			<div class="inner-avatar">
				<img :src="require(`@/assets/images/Jimmy.png`)" alt="" />
			</div>
			<div v-if="userData">
				<h1>{{ $t('hey') }} {{ userData.firstName }},</h1>
			</div>
			<div class="body-text-1 session-expire-text">
				{{ $t('sessionWillexpireText') }}
			</div>

			<ja-button
				class="confirm-button large"
				name="confirm-proceed-session"
				@click.native="proceedSession"
				>{{ $t('okay') }}</ja-button
			>
		</content>
	</ja-modal>
</template>
<script>
import ModalEvents from '../../mixins/ModalEvents';
import Modal from './Modal';
import Button from '../ui/Button';
import UserData from '../../mixins/UserData';

export default {
	components: {
		jaModal: Modal,
		jaButton: Button
	},
	mixins: [UserData, ModalEvents],
	props: {
		show: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {};
	},

	methods: {
		proceedSession() {
			this.$store.commit('setSessionWillExpireState', false);
			// Two times should be called this because JASA returns wrong cookie time first time.
			this.$store.dispatch('keepSessionAlive').then(() => {
				this.$store.dispatch('keepSessionAlive');
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.modal-wrapper {
	z-index: 1001;
	.session-expire-modal {
		padding: 64px 70px;

		h1 {
			margin: 0;
			margin-top: 14px;
		}

		h5 {
			margin: 8px 0;
		}

		.inner-avatar {
			position: relative;
			top: -125px;
			margin-bottom: -120px;
			background-color: #ffffff;
			border-radius: 50%;
			border: 4px solid #e7f8ff;
			width: 110px;
			height: 110px;

			img {
				width: 75px;
			}
		}
		.session-expire-text {
			margin-top: 15px;
			margin-bottom: 24px;
		}
	}
}
</style>
